export class WorldAssignmentError extends Error {
    constructor(public readonly id: number, message: string) {
        super(message);
    }
}
